/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Receivable/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Aggregated from './Aggregated/index'
import No from './No/index'
import React from 'react'
import Single from './Single/index'



/** @type {import('Simple/types.js').View} */
export default function Receivable({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Transactions/Content/Expanded/Receivable"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let entryValueData = fromData.useDataFormat({ viewPath,
context: 'entry',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: entryValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Aggregated'}>
<Aggregated
  viewPath={`${viewPath}/Aggregated`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Single'}>
<Single
  viewPath={`${viewPath}/Single`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}